import { useIntl, FormattedMessage } from "react-intl";

import { DEFAULT_VALUES } from "@/libraries/web-framework";
import {
    EnhancedBannerAlert,
    EnhancedBannerProps
} from "@/patterns/adg4/enhanced-banner-alert/enhanced-banner-alert";
import { experiments, useExperiment } from "@/utils/experiment";

type JiraEnhancedAboveNavBannersProps = {
    isGwp5090Test?: boolean;
};

const JiraEnhancedAboveNavBanners = ({
    isGwp5090Test
}: JiraEnhancedAboveNavBannersProps) => {
    const intl = useIntl();
    let template = <></>;

    const gwp5090BannerExperiment = useExperiment(
        experiments.gwp5090ExperimentBannerJira
    );
    const gwp5090IsButterBar =
        isGwp5090Test ||
        (gwp5090BannerExperiment &&
            gwp5090BannerExperiment.type === "enrolled" &&
            gwp5090BannerExperiment.value === "butterbar");

    if (gwp5090IsButterBar) {
        const gwp5090Team25Config: EnhancedBannerProps = {
            identifier: "GWP5090.jira-product-tour.butterbar",
            text: (
                <>
                    <FormattedMessage
                        id="team25-banners-and-butterbars.jira-software.text"
                        defaultMessage="<strong>April 8-10 • Anaheim, California</strong>Get a first look at the latest Jira features and AI advancements—only at Team &rsquo;25!"
                        values={DEFAULT_VALUES}
                    />
                </>
            ),
            mobileText: (
                <>
                    <FormattedMessage
                        id="team25-banners-and-butterbars.jira-software.mobile-text"
                        defaultMessage="<strong>April 8-10 • Anaheim, California</strong>Demo new features at Team &rsquo;25!"
                        values={DEFAULT_VALUES}
                    />
                </>
            ),
            productKey: "home",
            backgroundPreset: "gwp-5090-banners",
            imageProps: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/4360jv8l7u81b0w6nn37fu86a2131624.webp",
                alt: "Team25", //Event name is not localized
                width: 200
            },
            linkText: "Get your pass",
            linkUrl:
                "https://events.atlassian.com/team?utm_medium=event-web-referral&utm_source=jira_product-tour&event_context=701QB00000Lg6oBYAR&utm_campaign=K:event|H:any|N:Team_25|P:agnostic|O:event-marketing|F:pre-event|C:event-home&utm_content=butterbar-banner_WEBTEAM-17396&event_id=216653",
            dataEventProps: {
                "data-product-key": "home",
                "data-event-component": "linkButton",
                "data-event-container": "announcementBanner",
                "data-event": "clicked",
                "data-label": intl.formatMessage({
                    id: "team25-banners-and-butterbars.jira-software.cta",
                    defaultMessage: "Get your pass"
                }),
                "data-label-english": "Get your pass"
            }
        };

        template = <EnhancedBannerAlert {...gwp5090Team25Config} />;
    }
    return <div>{template}</div>;
};

JiraEnhancedAboveNavBanners.displayName = "JiraEnhancedAboveNavBanners";

export default JiraEnhancedAboveNavBanners;
